import type { TrendResponse } from '@testflow/shared';
import { useTranslation } from 'react-i18next';
import { QueryErrorNotice } from '../../query-error-notice.js';
import { TrendBars } from '../trend-bars.js';

// #97: Trend-Sektion — gestapelte Wochen-Säulen Blocker/Hoch aus den täglichen
// Snapshots (Task 6, /reports/trend). Eigene Query je Plan, gleiches Fehler-/Lade-
// Muster wie die REP-1/2/3/5-Kacheln in `reporting-page.tsx` (isSummaryError/
// isSummaryLoading): Query-Fehler nie als leere Fläche, Retry gezielt nur diese Query.
export function TrendCard({
  scopeHint,
  trend,
  isTrendLoading,
  isTrendError,
  onRetryTrend,
}: {
  // Task 7: Zuschnitt-Hinweis, aus dem Nutzer-Scope abgeleitet (scopeHintFrom). Gilt seitenweit
  // (nicht plan-abhängig) — wird hier nur durchgereicht, weil die Trend-Kachel ihre eigene
  // Ausnahme benennen muss (der Verlauf bleibt projektweit).
  // Diese Karte liest nur, OB ein Zuschnitt aktiv ist, nicht `label` — den namenlosen
  // Rückfalltext (`scope.hintFallback`) trägt der seitenweite Hinweis in `reporting-page.tsx`.
  scopeHint: { node_ids: string[]; label: string | null } | null;
  trend: TrendResponse | undefined;
  isTrendLoading: boolean;
  isTrendError: boolean;
  onRetryTrend: () => void;
}) {
  const { t } = useTranslation();

  return (
    <section className="rounded-card border border-[var(--border)] bg-bg-surface p-4">
      <div className="mb-1 flex items-center justify-between">
        <h2 className="text-sm font-bold text-text-primary">{t('reporting.trend.title')}</h2>
      </div>
      <p className="mb-3 text-[10px] text-text-muted">{t('reporting.scopePlan')}</p>
      {/* Task 7: der Verlauf hat keine Knoten-Dimension (Tagesstände werden projektweit
          gespeichert) und bleibt darum die eine Ausnahme vom Knoten-Zuschnitt — sonst läse
          sich ein zugeschnittener Nutzer die Wochenbalken fälschlich als "sein" Teilprojekt. */}
      {scopeHint ? (
        <p className="mb-3 text-xs text-text-muted" data-testid="scope-hint-trend">
          {t('scope.hintTrend')}
        </p>
      ) : null}
      {isTrendError ? (
        <QueryErrorNotice onRetry={onRetryTrend} />
      ) : isTrendLoading ? (
        <div className="text-sm text-text-muted">{t('common.loading')}</div>
      ) : trend ? (
        <TrendBars weeks={trend.weeks} />
      ) : null}
    </section>
  );
}
